export default __webpack_public_path__ + "static/iAWriterDuospace-Regular-2c47e77829b14754acdf5d728f89d62a.otf";